export default "__VITE_ASSET__0mQAzfJE__"